// extracted by mini-css-extract-plugin
export default {"root":"m8jXPZfOaUkMATE9NBfq","tab":"sT9uD6ibNjqmf7VLmI1N","wordBreak":"vIGDFUWacXZxH9ElH3UR"};